
import Swal from 'sweetalert2/dist/sweetalert2.js'
import { $, $$ } from '@/utilities/helpers';
import { tns } from 'tiny-slider';


/*------------------------------------------------------------------
 Carousel blocks
 ------------------------------------------------------------------*/

//Add an intersection observer to add an 'inview class to all elements with the class 'js-inview'
const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('inview');
        }
    });
});

setTimeout(() => $$('.js-inview').forEach(element => observer.observe(element)), 888);

let $sliders = $$('.js-carousel');

if ($sliders) {
    $sliders.forEach($slider => {

        let $previous_slide = $slider.parentNode.querySelector('.js-carousel-prev');
        let $next_slide = $slider.parentNode.querySelector('.js-carousel-next');

        let slider = tns({
            container: $slider.querySelector('.carousel-element__wrap'),
            items: 1,
            controls: false,
            loop: false,
            nav: false,
            gutter: 20,
            mouseDrag: true,
            slideBy: 1,
            mouseDrag: true,
            responsive: {
                400: {
                    items: 1.5
                },
                768: {
                    items: 2.5
                },
                1000: {
                    items: 2.5
                }
            }

        });

        if ($previous_slide) $previous_slide.addEventListener('click', () => slider.goTo('prev'));

        if ($next_slide) $next_slide.addEventListener('click', () => slider.goTo('next'));

        // Set the height of the carousel to the height of the current slide
        setTimeout(() => window.dispatchEvent(new Event('resize')), 111);
    });
}



/*------------------------------------------------------------------
Signup form
------------------------------------------------------------------*/
let $signupForms = $$('.js-signup-form');

$signupForms.forEach($signupForm => {

    $signupForm.addEventListener('submit', (e) => {
        e.preventDefault();

        // Send the form data to the server
        fetch(`${$signupForm.dataset.apiUrl}?signup_email=${$signupForm.querySelector('#signup_email').value}`)
            .then(response => response.json())
            .then(data => {
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-right',
                    iconColor: 'white',
                    customClass: {
                        popup: 'colored-toast',
                    },
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                })

                
                Toast.fire({
                    icon: (data.status === 'ok') ? 'success' : 'error',
                    title: data.message,
                })

            })

    });

});